import { render, staticRenderFns } from "./XIconComponent.vue?vue&type=template&id=e042ec92&"
import script from "./XIconComponent.vue?vue&type=script&lang=js&"
export * from "./XIconComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports